export const UPDATE_USER_MUTATION = gql`
    mutation updateUser($id: Int!, $input: UpdateUserInput!) {
        updateUser(id: $id, input: $input) {
            id
            firstName
            email
            lastName
            roleId
            phoneNumber
            countryCode
            sellerId
            pipeDriveUserId
            zenDeskUserId
            status
        }
    }
`;
